import React, { useState, useCallback, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from '@reach/router'; //eslint-disable-line
import ContactModal from './ContactModal';
import LandingHeader from './LandingHeader';
import NavbarContainer from './NavbarContainer';
import BlogTopHeader from './Blog/BlogTopHeader';
import BlogCategories from './Blog/BlogCategories';
import { NavContext } from './NavContext';

function Header({ isContactActive, setContactActive }) {
  const [mobileMenu, setMobileMenu] = useState(false);
  const { pathname } = useLocation();
  const [isOpen, setIsOpen] = useState(null);
  const mobileMenuClick = useCallback((e) => {
    if ((e.type === 'keydown' && e.key === 'Enter') || e.type === 'click')
      setMobileMenu((state) => !state);
  }, []);

  const setOpen = useCallback(
    (value) => () => setIsOpen((state) => (state === value ? null : value)),
    [],
  );

  const contactPopupClick = useCallback((e) => {
    if (e.key === 'Escape') {
      setContactActive(false);
    }
    if ((e.type === 'keydown' && e.key === 'Enter') || e.type === 'click')
      setContactActive((state) =>
        typeof state === 'boolean' && state === false
          ? {
              formType: 'generalQuery',
              title: 'Contact Us',
            }
          : false,
      );
  }, []);

  useEffect(() => {
    document.body.style.overflow = mobileMenu ? 'hidden' : 'visible';
  }, [mobileMenu]);
  const contextValues = useMemo(
    () => ({
      isOpen,
      mobileMenu,
      mobileMenuClick,
      setOpen,
      setMobileMenu,
      contactPopupClick,
    }),
    [isOpen, mobileMenu, mobileMenuClick, setOpen, contactPopupClick],
  );
  return (
    <>
      <NavContext.Provider value={contextValues}>
        {pathname.startsWith('/blog') && !process.env.GATSBY_AI ? (
          <>
            <BlogTopHeader>
              <LandingHeader blog />
            </BlogTopHeader>
            <NavbarContainer setContactActive={setContactActive}>
              <BlogCategories />
            </NavbarContainer>
          </>
        ) : (
          <NavbarContainer setContactActive={setContactActive}>
            {!process.env.GATSBY_AI ? <LandingHeader /> : null}
          </NavbarContainer>
        )}
      </NavContext.Provider>

      <div
        className={mobileMenu ? 'header-compesator show' : 'header-compesator'}
      />
      <ContactModal
        key={isContactActive?.formType ?? isContactActive}
        contactPopup={isContactActive}
        contactPopupClick={contactPopupClick}
      />
    </>
  );
}

Header.propTypes = {
  isContactActive: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.string,
    PropTypes.object,
  ]).isRequired,
  setContactActive: PropTypes.func.isRequired,
};

export default Header;
